export default __webpack_public_path__ + "images/YR.27b6cba.png";